import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { FiMenu, FiX } from 'react-icons/fi';
import logo from '../assets/logo.png'; // Certifique-se de ajustar o caminho correto para a logo
import { Link } from 'react-router-dom';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navRef = useRef();

  // Toggle do menu
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Função que fecha o menu ao clicar fora dele
  const handleClickOutside = (event) => {
    if (navRef.current && !navRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  // useEffect para adicionar o listener de clique fora do menu
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <HeaderContainer>
      <HeaderInner>
        <LogoContainer>
          <Link to="/">
            <img src={logo} alt="Logo da Empresa" />
          </Link>
        </LogoContainer>
        <Nav ref={navRef}>
          <MenuToggle onClick={toggleMenu}>
            {isOpen ? <FiX size={30} /> : <FiMenu size={30} />}
          </MenuToggle>
          <NavList isOpen={isOpen}>
            <NavItem><NavLink href="/">Início</NavLink></NavItem>
            <NavItem><NavLink href="/about">Sobre Nós</NavLink></NavItem>
            <NavItem><NavLink href="/projects">Projetos</NavLink></NavItem>
            <NavItem><NavLink href="/simulator">Simulador</NavLink></NavItem>
            <NavItem><NavLink href="/contact">Contato</NavLink></NavItem>
          </NavList>
          <NavActions>
            <NavActionLink href="/contact">Solicitar orçamento</NavActionLink>
          </NavActions>
        </Nav>
      </HeaderInner>
    </HeaderContainer>
  );
};

export default Header;

// Estilos com styled-components

const HeaderContainer = styled.header`
  background: rgba(11, 15, 26, 0.85);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  position: sticky;
  top: 0;
  z-index: 1000;
`;

const HeaderInner = styled.div`
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1280px;
  margin: 0 auto;
  width: 100%;

  @media (min-width: 900px) {
    padding: 16px 6%;
  }

  @media (max-width: 768px) {
    padding: 12px 16px;
  }
`;

const LogoContainer = styled.div`
  img {
    width: 140px;
    height: auto;

    @media (max-width: 768px) {
      width: min(120px, 45vw);
    }
  }
`;

const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: 24px;
`;

const MenuToggle = styled.button`
  display: none;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.primary};
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 8px;
  align-items: center;
  justify-content: center;
  margin-right: 40px;
  flex-shrink: 0;
  @media (max-width: 768px) {
    display: inline-flex;
    margin-right: 0;
  }
`;

const NavList = styled.ul`
  display: flex;
  gap: 24px;
  list-style: none;
  margin: 0;
  padding: 0;
  transition: max-height 0.3s ease;

  @media (max-width: 768px) {
    position: absolute;
    top: 100%;
    left: 16px;
    right: 16px;
    flex-direction: column;
    background-color: rgba(11, 15, 26, 0.95);
    max-height: ${({ isOpen }) => (isOpen ? '420px' : '0')};
    overflow: hidden;
    transition: max-height 0.5s ease;
    z-index: 999;
    border-radius: 16px;
    padding: ${({ isOpen }) => (isOpen ? '16px' : '0 16px')};
    border: 1px solid rgba(255, 255, 255, 0.08);
    box-shadow: 0 18px 40px rgba(0, 0, 0, 0.35);
  }
`;

const NavItem = styled.li`
  @media (max-width: 768px) {
    text-align: center;
    padding: 10px 0;
  }
`;

const NavLink = styled.a`
  color: ${({ theme }) => theme.colors.white};
  font-size: 15px;
  font-family: ${({ theme }) => theme.fonts.main};
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: color 0.3s ease, opacity 0.3s ease;
  opacity: 0.8;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    opacity: 1;
  }

  @media (max-width: 768px) {
    font-size: 18px;
    display: block;
    width: 100%;
  }
`;

const NavActions = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 900px) {
    display: none;
  }
`;

const NavActionLink = styled.a`
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.text};
  padding: 10px 18px;
  border-radius: 999px;
  font-size: 0.85rem;
  text-decoration: none;
  font-weight: 600;
  letter-spacing: 0.04em;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 24px rgba(255, 199, 0, 0.35);
  }
`;
